import { Component, OnInit,Input } from '@angular/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Router, NavigationExtras } from '@angular/router';
import { Strings } from '../../common/language/strings';
import { res } from '../../common/language/text/res';

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.css']
})
export class HeaderNavComponent implements OnInit {

  @Input() path: string;
  @Input() navigateExtras: NavigationExtras;

  lblGoBack = res.GoBack;

  faArrowLeft = faArrowLeft

  constructor(
    private _router: Router,
    public strings: Strings
    ) { }

  ngOnInit() {
  }

  goBack()
  {
    if(this.path === undefined || this.path === null || this.path ==='')
    {
      window.history.back();
    }
    else
    {
      this._router.navigate([this.path], this.navigateExtras).then((e) => {});
    }
  }
}
